module.exports = {"220421100":"东丰镇","220421101":"大阳镇","220421102":"横道河镇","220421103":"那丹伯镇","220421104":"猴石镇","220421105":"杨木林镇","220421106":"小四平镇","220421107":"黄河镇","220421108":"拉拉河镇","220421109":"沙河镇","220421110":"南屯基镇","220421111":"大兴镇","220421200":"三合满族朝鲜族乡","220421201":"二龙山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220421.json
// module id = 582
// module chunks = 0